export const SUPPORT_EXAMPLE_QUESTIONS = [
    "I'd like to run a short-circuit current simulation, can you help me get started?",
    'Can you help me configure voltage droop control?',
    'How does droop control work?',
    'How should I control my DC bus?',
    "I'm looking for a fuse that coordinates with my upstream breaker",
    "I'm looking for a protection device for my 800V DC bus",
    'My simulation failed, how do I find out what went wrong?',
    'Can you review my fault simulation results?',
    'Size my battery for 4 hours of backup.',
    'Will this EV charger work on my DC bus?',
    'How can I set up a power flow sim and run it?',
    'Check equipment interoperability in my design.',
    'Generate an energy analysis report.',
    'Turn my simulation results into a presentation.',
    'Get me to a valid BOM.',
];
